import React, { useState, useEffect } from 'react';
import { 
  Drawer, 
  Form, 
  Input, 
  Select, 
  Button
} from 'antd';
import { 
  UserOutlined,
  FilterOutlined,
  CloseOutlined,
  ClearOutlined
} from '@ant-design/icons';
import styles from '../common/DrawerModalMobile.module.css';

const { Option } = Select;

interface FilterModalMobileProps {
  isOpen: boolean;
  onClose: () => void;
  filters: {
    name: string;
    relationship: string | undefined;
    status: boolean | undefined;
  };
  onApplyFilters: (filters: {
    name: string;
    relationship: string | undefined;
    status: boolean | undefined;
  }) => void;
  onClearFilters: () => void;
}

export const FilterModalMobile: React.FC<FilterModalMobileProps> = ({
  isOpen,
  onClose,
  filters,
  onApplyFilters,
  onClearFilters
}) => {
  const [form] = Form.useForm();
  const [hasActiveFilters, setHasActiveFilters] = useState(false);

  useEffect(() => {
    if (isOpen) {
      form.setFieldsValue(filters);
      checkActiveFilters(filters);
    }
  }, [isOpen, filters]);

  const checkActiveFilters = (currentFilters: typeof filters) => {
    const hasFilters = Boolean(
      currentFilters.name || 
      currentFilters.relationship || 
      currentFilters.status !== undefined
    );
    setHasActiveFilters(hasFilters);
  };

  const handleApplyFilters = () => {
    const values = form.getFieldsValue();
    onApplyFilters(values);
    onClose();
  };

  const handleClearFilters = () => {
    form.resetFields();
    onClearFilters();
    setHasActiveFilters(false);
  };

  const handleFormChange = () => {
    const values = form.getFieldsValue();
    checkActiveFilters(values);
  };

  return (
    <Drawer
      title="Bộ lọc khách mời"
      open={isOpen}
      onClose={onClose}
      placement="bottom"
      height="70%"
      className={styles.drawer}
      bodyStyle={{ padding: 0 }}
      headerStyle={{ 
        borderBottom: '1px solid #f0f0f0',
        padding: '16px 20px'
      }}
    >
      <div className={styles.drawerContent}>
        <div className={styles.drawerBody}>
          <Form
            form={form}
            layout="vertical"
            onValuesChange={handleFormChange}
          >
            <div className={styles.formItem}>
              <Form.Item
                name="name"
                label="Tìm kiếm"
              >
                <Input 
                  placeholder="Tìm kiếm theo tên, SĐT, email..." 
                  className={styles.inputNumber}
                  prefix={<UserOutlined />}
                  allowClear
                />
              </Form.Item>
            </div>

            <div className={styles.formItem}>
              <Form.Item
                name="relationship"
                label="Mối quan hệ"
              >
                <Select 
                  placeholder="Chọn mối quan hệ"
                  className={styles.select}
                  allowClear
                >
                  <Option value="family_internal">Gia đình nội</Option>
                  <Option value="family_external">Gia đình ngoại</Option>
                  <Option value="friend_bride">Bạn cô dâu</Option>
                  <Option value="friend_groom">Bạn chú rể</Option>
                  <Option value="colleague">Đồng nghiệp</Option>
                  <Option value="business_partner">Đối tác</Option>
                  <Option value="other">Khác</Option>
                </Select>
              </Form.Item>
            </div>

            <div className={styles.formItem}>
              <Form.Item
                name="status"
                label="Trạng thái"
              >
                <Select 
                  placeholder="Chọn trạng thái"
                  className={styles.select}
                  allowClear
                >
                  <Option value={true}>Hoạt động</Option>
                  <Option value={false}>Không hoạt động</Option>
                </Select>
              </Form.Item>
            </div>
          </Form>
        </div>

        <div className={styles.drawerFooter}>
          <div className={styles.drawerFooterRow}>
            <Button
              className={`${styles.drawerFooterButton} ${styles.default}`}
              onClick={onClose}
              icon={<CloseOutlined />}
            >
              Đóng
            </Button>
            {hasActiveFilters && (
              <Button
                className={`${styles.drawerFooterButton} ${styles.default}`}
                onClick={handleClearFilters}
                icon={<ClearOutlined />}
              >
                Xóa bộ lọc
              </Button>
            )}
            <Button
              type="primary"
              className={`${styles.drawerFooterButton} ${styles.primary}`}
              onClick={handleApplyFilters}
              icon={<FilterOutlined />}
            >
              Áp dụng
            </Button>
          </div>
        </div>
      </div>
    </Drawer>
  );
};
